function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Omannet = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, React) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = void 0;
  React = _interopRequireWildcard(React);

  function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

  function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

  function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

  var SvgOmannet = function SvgOmannet(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: props.className,
      style: props.style
    }, /*#__PURE__*/React.createElement("svg", _extends({
      viewBox: "0 0 60 40",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/React.createElement("path", {
      fill: "#F3F6F9",
      d: "M0 0h60v40H0z"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M20.8 23.484h-1.913c.389-.31.45-.606.45-1.12v-1.96c0-.513-.061-.824-.435-1.135h.996c.14 0 .218-.016.326-.124v.668c.436-.45 1.074-.7 1.758-.7.7 0 1.26.311 1.524.778.467-.498 1.151-.778 1.945-.778 1.275 0 1.913.607 1.913 1.805V22.41c0 .435.015.715.435 1.073h-1.897c.389-.31.45-.606.45-1.12v-1.057c0-.934-.31-1.385-1.119-1.385-.84 0-1.4.53-1.4 1.431v1.011c0 .467.016.778.451 1.12h-1.913c.404-.326.451-.622.451-1.12v-1.057c0-.934-.311-1.385-1.089-1.385-.809 0-1.369.514-1.369 1.431v1.011c-.015.467-.015.762.436 1.12z",
      fill: "url(#omannet_svg__paint0_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M30.117 23.624c-1.353 0-2.084-.482-2.084-1.26 0-1.197 1.26-1.524 3.857-1.54v-.03c0-.67-.342-.918-1.166-.918-.53 0-1.385.155-2.364.56l.388-1.167c.063.031.14.047.218.047.436 0 1.104-.187 1.944-.187 1.416 0 1.991.56 1.991 1.851v1.338c0 .466.063.793.56 1.182h-1.01c-.172 0-.312-.14-.358-.39-.452.343-1.12.514-1.976.514zm-1.042-1.384c0 .373.404.638 1.167.638 1.042 0 1.648-.467 1.648-1.074v-.248c-1.897.03-2.815.14-2.815.684z",
      fill: "url(#omannet_svg__paint1_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M35.717 23.484h-1.913c.404-.326.45-.622.45-1.12v-1.96c0-.513-.062-.808-.435-1.135h.996c.14 0 .248-.031.326-.124v.668c.514-.482 1.151-.7 1.96-.7 1.291 0 1.913.591 1.913 1.805v1.43c0 .483.016.779.436 1.12h-1.898c.405-.326.436-.622.436-1.12v-1.12c0-.933-.28-1.4-1.182-1.4-.965 0-1.571.514-1.571 1.432v1.089c.03.497.062.793.482 1.135z",
      fill: "url(#omannet_svg__paint2_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M41.487 22.442c.016.513.094.825.467 1.042H39.98c.358-.202.466-.513.466-1.042V19.02c0-.529-.108-.855-.466-1.042l1.493.015 3.749 3.796-.016-2.816c0-.544-.124-.87-.467-1.042h1.93c-.42.25-.436.56-.436 1.011V23.733c-.016-.015-.218-.015-.436-.124a3.473 3.473 0 01-1.058-.763l-3.313-3.39.063 2.986z",
      fill: "url(#omannet_svg__paint3_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M50.167 22.924c-1.167 0-2.131-1.01-2.131-1.586v-.031h4.184c0-1.4-.917-2.24-2.706-2.24-1.758 0-2.691 1.26-2.691 2.224 0 1.384 1.182 2.411 3.064 2.333 2.178-.093 2.364-1.135 2.364-1.135-.668.389-1.306.435-2.084.435zm-.591-3.157c.887 0 1.384.357 1.384.87v.016h-2.877c.046-.513.575-.886 1.493-.886z",
      fill: "url(#omannet_svg__paint4_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M54.304 21.602V20.015h1.68v-.762H54.32v-.824-.078-.342h-.529c0 1.198-.326 1.524-1.384 1.524l.155.482h.732l-.016 1.51v.435c0 .466.031.886.373 1.26.296.31.685.435 1.245.435.808 0 1.104-.793 1.104-.793-.28.14-.902.156-.902.156-.7-.032-.794-.732-.794-1.416z",
      fill: "url(#omannet_svg__paint5_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12.603 16.92l-2.38-6.175.59-.218 2.365 6.175-.575.218z",
      fill: "url(#omannet_svg__paint6_linear)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.185 16.625l-.607-.078.498-3.391.622.078-.513 3.39z",
      fill: "url(#omannet_svg__paint7_linear)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17.129 17.807l-.482-.405 4.682-5.74.482.39-4.682 5.755z",
      fill: "url(#omannet_svg__paint8_linear)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M11.047 18.04l-3.002-2.784.42-.451 3.002 2.768-.42.467z",
      fill: "url(#omannet_svg__paint9_linear)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5.839 19.358l-.062.62 4.473.445.062-.619-4.473-.446z",
      fill: "#55B350"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7.407 24.76l-.31-.545 3.701-2.1.311.545-3.702 2.1z",
      fill: "url(#omannet_svg__paint10_linear)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13.163 27.59l-.607-.108.762-3.998.607.125-.762 3.982z",
      fill: "url(#omannet_svg__paint11_linear)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18.7 29.504l-3.049-5.864.545-.296 3.064 5.88-.56.28z",
      fill: "url(#omannet_svg__paint12_linear)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.325 21.447h-.031c-.203-.171-.467-.39-.794-.716-.062-.062-.14-.14-.186-.202.015-.047.015-.109.015-.171v-.094c.062-.062.11-.124.156-.186h.015v.015c0 .063.078.11.187.11.078 0 .155-.032.171-.079h.093v.063c0 .03.031.062.063.062h.668a.067.067 0 00.063-.062v-.311a.067.067 0 00-.063-.063h-.668a.067.067 0 00-.063.063v.062h-.093c-.016-.047-.093-.094-.187-.094h-.015c.435-.762.73-1.4.653-1.446-.078-.031-.498.544-.949 1.306l.031.016c-.015.031-.046.062-.077.109v-.467c-.094 0-.156-.046-.156-.109h-.015v-.108h-.016v-.187h-.016V18.74c.016 0 .031-.015.047-.015.031-.016.047-.016.062-.032a.214.214 0 00.047-.062h.016a.067.067 0 00.062-.062.067.067 0 00-.063-.062h-.015c-.016-.031-.031-.047-.062-.078-.016-.016-.047-.016-.063-.031-.015-.016-.046-.016-.062-.016a.067.067 0 00-.062-.062.067.067 0 00-.062.062c-.016 0-.047.016-.062.016-.031.015-.047.015-.063.031-.03.016-.046.047-.062.078h-.015a.067.067 0 00-.063.062c0 .031.032.062.063.062h.015a.214.214 0 01.047.062c.015.016.031.031.062.031 0 0 .016 0 .016.016V18.958h-.016v.218h-.015v.109h-.016c0 .062-.062.108-.155.108V19.86c-.032-.047-.063-.078-.078-.109l.03-.015c-.435-.763-.855-1.354-.948-1.307-.078.031.202.669.638 1.415-.094 0-.171.047-.187.094h-.093v-.047a.067.067 0 00-.063-.062h-.668a.067.067 0 00-.063.062v.311c0 .031.031.062.063.062h.668a.067.067 0 00.063-.062v-.078h.109c.03.047.093.078.17.078.079 0 .156-.03.172-.078a.119.119 0 00.078.032c.03.046.062.077.093.124 0 .062-.016.093-.031.109h-.093v.015c-.156.016-.467.016-.732.032v-.016l-.124.015c-.187.016-.327.063-.327.125s.14.14.327.187v.015l.124.031v-.015c.171.046.374.078.545.109-.265.248-.482.435-.654.575l-.015-.015c-.264.295-.544.42-.451.466.109.062.466-.078.793-.389h-.015c.202-.17.45-.373.684-.622.202 0 .342-.047.451-.14l.047.047c.28.28.544.513.777.715h-.015c.327.311.7.436.793.39.125-.048-.155-.187-.435-.467zm-.7-1.603l.03.016h-.03v-.016z",
      fill: "#B2141C"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13.987 16.733c-2.52 0-3.998 1.447-3.998 3.578 0 2.147 1.447 3.5 3.827 3.5 2.52 0 3.997-1.462 3.997-3.578 0-2.162-1.43-3.5-3.826-3.5zm-.187 6.331c-1.664 0-2.675-1.026-2.675-2.722 0-1.804 1.089-2.893 2.893-2.893 1.68 0 2.644.995 2.644 2.769 0 1.757-1.057 2.846-2.862 2.846z",
      fill: "#3CA647"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M14.003 16.33c-2.8 0-4.449 1.601-4.449 3.966 0 2.38 1.602 3.888 4.262 3.888 2.8 0 4.449-1.633 4.449-3.966 0-2.396-1.603-3.889-4.262-3.889zm-.171 7.217c-2.225 0-3.547-1.26-3.547-3.252 0-1.975 1.384-3.313 3.718-3.313 2.224 0 3.546 1.245 3.546 3.251-.015 1.96-1.384 3.314-3.717 3.314z",
      fill: "#B2141C"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M15.387 14.058a.855.855 0 100-1.71.855.855 0 000 1.71z",
      fill: "url(#omannet_svg__paint13_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M21.562 12.72a.856.856 0 100-1.71.856.856 0 000 1.71z",
      fill: "url(#omannet_svg__paint14_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M10.518 11.492a.855.855 0 100-1.711.855.855 0 000 1.71z",
      fill: "url(#omannet_svg__paint15_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M8.247 15.894a.855.855 0 100-1.711.855.855 0 000 1.71z",
      fill: "url(#omannet_svg__paint16_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M5.805 20.529a.856.856 0 100-1.711.856.856 0 000 1.71z",
      fill: "url(#omannet_svg__paint17_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M7.252 25.335a.855.855 0 100-1.71.855.855 0 000 1.71z",
      fill: "url(#omannet_svg__paint18_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M12.898 28.322a.855.855 0 100-1.711.855.855 0 000 1.71z",
      fill: "url(#omannet_svg__paint19_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M18.902 30.22a.856.856 0 100-1.712.856.856 0 000 1.711z",
      fill: "url(#omannet_svg__paint20_radial)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M32.264 13.358c.264 0 .466-.233.466-.529 0-.295-.217-.529-.466-.529-.265 0-.467.234-.467.53 0 .295.202.528.467.528zM26.633 13.234c.264 0 .466-.234.466-.53 0-.295-.217-.528-.466-.528-.249 0-.467.233-.467.529 0 .295.203.529.467.529zM27.66 13.234c.264 0 .466-.234.466-.53 0-.295-.218-.528-.466-.528-.265 0-.467.233-.467.529 0 .295.218.529.466.529zM33.68 15.987v-2.411s-.872.14-1.136.187c.233.17.233.497.233.793v1.54h-1.944v-2.52s-.871.14-1.136.187c.233.17.233.497.233.793v1.54h-3.935c-.544 0-.933-.125-.933-.747 0-.56.762-1.01 1.29-.949.639.078.856.576.856.576v-.793s-1.073-.39-1.866 0c-.793.388-1.042 1.01-1.027 1.477.016.467.56.871.762.871h8.82c-.016-.015-.218-.078-.218-.544z",
      fill: "#B2141C"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M50.385 15.831s-.187.203-.39.203h-1.01c-.28 0-.622-.171-.622-.98 0-.81.389-1.12.762-1.12.575 0 .762.995.762.995l.218-.653s-.25-.731-.996-.731c-1.104 0-1.57.762-1.57 1.353 0 .405.046.809.31 1.12h-2.302c.031-.14.047-.296.047-.436 0-.917-.591-1.648-1.322-1.648-.731 0-1.322.746-1.322 1.649 0 .155.015.295.046.435h-2.364v-3.889s-.653.203-.918.327c.187.171.187.327.187.809v2.333c0 .778-.482.918-.482.918h3.748c.234.435.638.715 1.09.715.45 0 .855-.28 1.088-.715h4.635c.467 0 .405-.685.405-.685zm-6.098 1.011c-.389 0-.715-.56-.715-1.244 0-.684.31-1.244.715-1.244.39 0 .716.56.716 1.244-.016.684-.327 1.244-.716 1.244z",
      fill: "url(#omannet_svg__paint21_linear)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M36.914 13.887c.265 0 .467-.233.467-.529 0-.295-.218-.529-.467-.529-.248 0-.466.234-.466.53 0 .295.202.528.466.528z",
      fill: "url(#omannet_svg__paint22_linear)"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M37.723 13.934c.031 0 .094.062.125.093.03.031.062.078.093.109.062.093.078.218.093.327.047.528.047 1.228-.108 1.742-.125.389-.39.73-.81.824-.108.031-.217.031-.341.031a1.173 1.173 0 01-1.043-.73c-.233-.545-.17-1.276-.124-1.852.016-.218.109-.42.311-.529h-1.431c.031 0 .093.063.124.094.032.03.063.077.094.124.062.109.077.233.093.342.016.202-.016.56-.016.762 0 .39.032.778.187 1.12.14.343.389.623.7.81.358.217.793.28 1.213.28.467 0 .95-.11 1.307-.405.498-.42.684-1.136.669-1.758 0-.202-.016-.544-.016-.747a.71.71 0 01.078-.357c.031-.063.062-.11.093-.156.031-.031.11-.109.14-.109 0-.015-1.43-.015-1.43-.015z",
      fill: "url(#omannet_svg__paint23_linear)"
    }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
      id: "omannet_svg__paint0_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(32.556 18.075) scale(7.37459)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "omannet_svg__paint1_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(32.556 18.075) scale(7.3746)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "omannet_svg__paint2_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(32.556 18.075) scale(7.37459)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "omannet_svg__paint3_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(46.26 16.699) scale(7.24627)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "omannet_svg__paint4_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(46.26 16.699) scale(7.24627)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "omannet_svg__paint5_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(46.26 16.699) scale(7.24627)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "omannet_svg__paint13_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(15.383 13.196) scale(.85645)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "omannet_svg__paint14_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(21.566 11.86) scale(.85645)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "omannet_svg__paint15_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(10.517 10.637) scale(.85645)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "omannet_svg__paint16_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(8.252 15.03) scale(.85645)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "omannet_svg__paint17_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(5.806 19.673) scale(.85645)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "omannet_svg__paint18_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(7.256 24.485) scale(.85645)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "omannet_svg__paint19_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(12.895 27.46) scale(.85645)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("radialGradient", {
      id: "omannet_svg__paint20_radial",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "translate(18.896 29.363) scale(.85645)"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "omannet_svg__paint6_linear",
      x1: 10.624,
      y1: 10.36,
      x2: 11.831,
      y2: 14.111,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "omannet_svg__paint7_linear",
      x1: 15.479,
      y1: 12.956,
      x2: 14.931,
      y2: 16.018,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "omannet_svg__paint8_linear",
      x1: 22.165,
      y1: 11.828,
      x2: 19.502,
      y2: 14.458,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "omannet_svg__paint9_linear",
      x1: 8.363,
      y1: 14.958,
      x2: 10.1,
      y2: 16.786,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "omannet_svg__paint10_linear",
      x1: 8.254,
      y1: 24.018,
      x2: 9.122,
      y2: 23.423,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "omannet_svg__paint11_linear",
      x1: 12.67,
      y1: 27.597,
      x2: 13.317,
      y2: 25.269,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "omannet_svg__paint12_linear",
      x1: 19.195,
      y1: 29.701,
      x2: 16.91,
      y2: 25.405,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#D0665B"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#B2141C"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "omannet_svg__paint21_linear",
      x1: 37.38,
      y1: 13.74,
      x2: 42.628,
      y2: 14.724,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "omannet_svg__paint22_linear",
      x1: 38.332,
      y1: 12.28,
      x2: 35.659,
      y2: 14.308,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })), /*#__PURE__*/React.createElement("linearGradient", {
      id: "omannet_svg__paint23_linear",
      x1: 39.154,
      y1: 13.364,
      x2: 36.481,
      y2: 15.391,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/React.createElement("stop", {
      stopColor: "#55B350"
    }), /*#__PURE__*/React.createElement("stop", {
      offset: 1,
      stopColor: "#108F34"
    })))));
  };

  var _default = SvgOmannet;
  _exports["default"] = _default;
});